import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ButtonComponent } from '../../components/button/button.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { DropdownService } from '../../services/dropdown.service';
import { CityService } from '../../services/city.service';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { FilterByKeyAndValuePipe } from '../../pipes/filter-by-key-and-value.pipe';
import { ValidationService } from '../../services/validation.service';
import { DropdownUploadButtonComponent } from '../../components/dropdown-upload-button/dropdown-upload-button.component';

@Component({
  selector: 'app-city-list-page',
  imports: [HeaderComponent, ButtonComponent, FilterByKeyAndValuePipe, CommonModule, ConfirmationPopupComponent, ModalComponent, TextInputComponent, ReactiveFormsModule, PluralPipe, AgGridListComponent, SelectInputComponent, SearchInputComponent, BulkUploadComponent,DropdownUploadButtonComponent],
  templateUrl: './city-list-page.component.html',
  styleUrl: './city-list-page.component.css'
})

export class CityListPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;

  @ViewChild('bulk_modal') bulk_modal: any
  page_name = 'City/Town';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  items: any[] = [];
  isSubmitting = false;
  show_menu = false;

  city_cols: any = [
    { field: 'District.State.country.name', headerName: 'Country', filter: true, flex: 1, },
    { field: 'District.State.name', headerName: 'State', filter: true, flex: 1, },
    // { field: 'District.name', headerName: 'Division', filter: true, flex: 1, },
    { field: 'District.name', headerName: 'District', filter: true, flex: 1, },
    // { field: 'name', headerName: 'Taluka', filter: true, flex: 1, },
    { field: 'name', headerName: 'City Name', filter: true, flex: 1, },
    { field: 'code', headerName: 'City Code', filter: true, flex: 1, },
    { headerName: "", sortable: false, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', width: 130, minWidth: 130, maxWidth: 130 }
  ];

  bulk_columns = [
    { column_name: 'Country Name', type: 'link', linked_list: 'country_list', linked_from: 'country', return_as: 'country_id', returning_key: 'id', sample_value: 'India' },
    { column_name: 'State Name', type: 'link', linked_list: 'state_list', return_as: 'state_id', returning_key: 'id', sample_value: 'Maharashtra', parent_column: 'country_id', parent_key: 'country.id' },
    { column_name: 'District Name', type: 'link', linked_list: 'district_list', returning_key: 'id', return_as: 'district_id', sample_value: 'Thane', parent_column: 'state_id', parent_key: 'State.id' },
    { column_name: 'City Name', type: 'text', return_as: 'name', sample_value: 'Mumbai', is_unique: true, min_length: this.vs.min_length_name, max_length: this.vs.max_length_name, regex: this.vs.location_name_pattern, regex_error: `Please enter a valid ${this.page_name} Name` },
    { column_name: 'Code', type: 'text', return_as: 'code', sample_value: 'Mumbai', min_length: this.vs.min_length_code, max_length: this.vs.max_length_code, regex: this.vs.code_pattern },
    // { column_name: 'Status', type: 'text', return_as: 'is_active', sample_value: true },
  ];

  actions(row: any) {
    let actions: any = []
    actions.push({ text: row.is_active ? 'Disable' : 'Enable', shortcut: 'u', color: 'gray', icon: row.is_active ? 'bx bx-block' : 'bx bx-check-circle', function: this.disable.bind(this), permissions: this.gs.user_role_data?.masters_location_disable })
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this), permissions: this.gs.user_role_data?.masters_location_view })
    actions.push({ text: 'Edit', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', disabled: row.is_active === false, function: this.open_form_modal.bind(this), permissions: this.gs.user_role_data?.masters_location_update })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.delete_modal_open.bind(this), permissions: this.gs.user_role_data?.masters_location_delete })
    return actions
  }

  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public cs: CityService, public ar: ActivatedRoute, public ds: DropdownService, public vs: ValidationService) {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.location_name_pattern)]],
      code: ['', [Validators.required, Validators.minLength(this.vs.min_length_code), Validators.maxLength(this.vs.max_length_code), Validators.pattern(this.vs.code_pattern)]],
      country_id: ['', [Validators.required]],
      state_id: ['', [Validators.required]],
      // division_id: ['', [Validators.required]],
      // taluka_id: ['', [Validators.required]],
      district_id: ['', [Validators.required]],
      is_active: [true]
    });
  }

  async ngOnInit() {
    await this.ds?.get_dropdown_list(['country', 'state', 'distric']);
    this.ar.queryParams.subscribe(async (params: any) => {
      this.params = { ...params }
      await this.get_list(this.params)
    })
  }

  async get_list(filter?: any) {
    try {
      const res = await this.cs.get_list(filter);
      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }

  download() {
    const data: any[] = (this.items as any)?.data || [];
    if (!data.length) return;
    const escape = (v: any) => { const s = String(v ?? ''); return s.includes(',') || s.includes('"') || s.includes('\n') ? `"${s.replace(/"/g, '""')}"` : s; };
    let csv = 'Country,State,District,City,City Code\n';
    for (const row of data) {
      csv += [escape(row.District?.State?.country?.name), escape(row.District?.State?.name), escape(row.District?.name), escape(row.name), escape(row.code)].join(',') + '\n';
    }
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'City_List.csv';
    link.click();
    window.URL.revokeObjectURL(url);
  }

  async delete_modal_open(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }

  async disable(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_disabled_modal?.open();
  }

  open_view_modal(item: any) {
    console.log(item);
    this.selected_ids = item || {};
    this.view_modal?.open();
  }

  async delete_city() {
    try {
      let res = await this.cs.delete(this.selected_ids.id);
      if (res != undefined) {
        this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      }
      this.selected_ids = {};
      this.confirmation_delete_modal?.close()
      this.ds.invalidate_dropdown_cache('city');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');
    }
  }

  async update_country(item: any) {
    try {
      let form_value = this.form.value;
      let data = item == true ? form_value.is_active == false : form_value.is_active == true
      let update = await this.cs.update(this.selected_ids.id, { is_active: data });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_delete_modal?.close()
      this.ds.invalidate_dropdown_cache('city');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  async bulk_delete(ids: any[]) {
    try {
      for (let id of ids) {
        let res = await this.cs.delete(id);
      }
      this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
      this.ds.invalidate_dropdown_cache('city');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');
    }
  }

  open_form_modal(item?: any) {
    if (item?.id) {
      this.route.navigate(['city/form'], { queryParams: { id: item.id } });
    } else {
      this.route.navigate(['city/form']);
    }
  }



  close_form_modal(): void {
    this.form_modal?.close();
  }

  async submit() {
    try {
      if (this.isSubmitting) {
        return;
      }
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      this.isSubmitting = true;
      let form_value = this.form.value;
      delete form_value.country_id
      delete form_value.state_id
      form_value.is_active = true;
      if (this.selected_ids && this.selected_ids.id) {
        let update_response = await this.cs.update(this.selected_ids.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.cs.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      this.ds.invalidate_dropdown_cache('city');
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');
    } finally {
      this.isSubmitting = false;
    }
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        is_active: true
      }));
      await this.gs.bulk_form_submission(updatedData, this.cs, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');

    }
  }

  dropdownRegistry: { [depended: number]: any } = {};

  registerDropdown(event: { depended: number; ref: any }) {
    this.dropdownRegistry[event.depended] = event.ref;
  }

  onDropdownChange(event: { value: any, depended: number }) {
    console.log("Dropdown changed:", event);

    const current = event.depended;
    for (const key of Object.keys(this.dropdownRegistry).map(Number)) {
      if (key > current) {
        this.dropdownRegistry[key]?.reset();
      }
    }
  }
}
